import { render, staticRenderFns } from "./CustomerRecord.vue?vue&type=template&id=20ca487e&scoped=true&lang=pug&"
import script from "./CustomerRecord.vue?vue&type=script&lang=js&"
export * from "./CustomerRecord.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecord.vue?vue&type=style&index=0&id=20ca487e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca487e",
  null
  
)

export default component.exports